module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/readable-stream/duplex-browser.js
// module id = ../../../../readable-stream/duplex-browser.js
// module chunks = common